var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "bg-white card mb-2",
          staticStyle: { "min-height": "90px" },
        },
        [
          _vm.isStatusDone
            ? _c(
                "div",
                {
                  staticClass: "card-body d-flex justify-content-evenly",
                  staticStyle: { gap: "1.25rem", "justify-content": "left" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex gap-100 w-100 flex-column" },
                    _vm._l(_vm.results, function (result, key) {
                      return _c(
                        "div",
                        {
                          staticClass:
                            "d-inline-flex align-items-center justify-content-evenly bg-white w-100",
                          class: { "border-top": key !== 0 },
                        },
                        [
                          _c("i", {
                            staticClass: "toast-icon",
                            class: {
                              "far fa-exclamation-circle text-danger":
                                !_vm.isValidationSuccessful(result),
                              "far fa-check-circle text-success":
                                _vm.isValidationSuccessful(result),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-75 text-normal" }, [
                            _c("p", {
                              staticClass: "my-3",
                              domProps: {
                                innerHTML: _vm._s(_vm.getMainText(result)),
                              },
                            }),
                            _vm._v(" "),
                            result?.errors
                              ? _c("div", [
                                  _c(
                                    "ul",
                                    { staticClass: "pl-2" },
                                    _vm._l(
                                      _vm.cleanupErrors(result),
                                      function (error) {
                                        return _c(
                                          "li",
                                          { staticClass: "font-size-100" },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(error.rule) +
                                                "\n                            "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              )
            : _vm.isStatusLoading
            ? _c("LoadingAnimation", {
                staticClass: "my-auto",
                attrs: { "animation-style": "bars" },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }